import styled from 'styled-components';

export const StyledWeatherGraphWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const StyledWeatherGraphCardTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #2f2f35;
`;
